export enum ContactsActionType {
  FETCH_CONTACTS = "FETCH_CONTACTS",
  FETCH_CONTACTS_START = "FETCH_CONTACTS_START",
  FETCH_CONTACTS_SUCCESS = "FETCH_CONTACTS_SUCCESS",
  FETCH_CONTACTS_FAIL = "FETCH_CONTACTS_FAIL"
}
